export default "__VITE_ASSET__JNAAA7QO__"